import React from "react";

export default function Logo({ size = "md", subtitle = false, className = "" }) {
  const heights = {
    sm: "h-8",
    md: "h-14",
    lg: "h-24",
  };
  const h = heights[size] || heights.md;
  return (
    <div className={`inline-flex items-center ${className}`} data-testid="brand-logo">
      <img
        src="/brand/logo.png"
        alt="GoProtege Logo"
        className={`${h} w-auto object-contain dark:hidden`}
      />
      <img
        src="/brand/logo_white.png"
        alt="GoProtege Logo"
        className={`${h} w-auto object-contain hidden dark:block`}
      />
    </div>
  );
}





